export const retouching = [
  {
    Image:
      "https://www.photographersedit.com/wp-content/uploads/2024/05/Emily-magers-for-web-768x768.jpg",
    title: "People Retouch",
    para1:
      "Enhance your portraits with our specialized People Retouching service. Whether you’re looking to soften skin, remove stray hairs, whiten eyes or teeth, or eliminate blemishes, we’ve got you covered. Our service goes beyond basic corrections—if you need adjustments to lighting, texture enhancements, or natural color enhancements, we can tailor the retouching to meet your specific needs.",
    para2: "Our People Retouching Services Include:",

    list1: "Skin Smoothing:",
    list2: "Stray Hair Removal",
    list3: "Eye & Teeth Whitening",
    list4: "Blemish Removal",
    list5: "Lighting Adjustments",
    list6: "Texture & Color Enhancement",
    para3:
      "For specific requirements or custom retouching needs, feel free to reach out to us. We’re here to help you achieve the perfect look for your images.",
  },
  {
    Image:
      " https://www.photographersedit.com/wp-content/uploads/2024/05/Lulu-for-web-1-768x768.jpg",
    title: "Newborn Retouching",
    para1:
      "Our newborn photo retouching service is dedicated to capturing the pure and delicate beauty of your baby’s first moments. We carefully enhance each image to bring out the softness and innocence of your newborn, ensuring that the photos reflect the true essence of these precious early days. Our service includes gentle skin smoothing, removing any minor blemishes, and refining the overall tone to highlight the natural beauty of your baby. We also adjust lighting and color balance to create a warm, inviting atmosphere in every photo, preserving the tender emotions of these special moments.",
    para2: "Our Newborn Retouching service includes:",
    list1: "Basic Editing & Cleanup",
    list2: "Sharpening",
    list3: "Dead Skin Removal",
    list4: "Softening of skin",
    list5: "Reducing redness in hands/feet",
    list6: "Advance Retouching",
    list7: "Parent Retouching",
  },

  {
    Image:
      "https://www.photographersedit.com/wp-content/uploads/2024/12/Custom-retouch_football-player-768x763.jpg",
    title: "Event Photo Retouching",
    para1:
      "Our event photo retouching service is dedicated to enhancing the visual appeal of your special occasions, ensuring that every moment is captured with clarity and style. We carefully edit each image to highlight the key elements of the event, such as the ambiance, guests, and décor. This includes adjusting lighting and color balance to enhance the overall atmosphere, smoothing out any imperfections, and removing distractions that might detract from the scene. Our goal is to ensure that every detail contributes to the story of your event, creating a polished and professional finish",
    para2: "Our Event Photo Retouching Services include:",

    list1: "Color Correction",
    list2: "Basic Cleanup",
    list3: "Eye Whitening",
    list4: "Teeth Whitening",
    list5: "Stray Hair Removal",
    list6: "Distraction Removal",
    list7: "Under-Eye Bag Reduction",
    list8: "Skin Smoothing",
  },

  {
    Image:
      "https://www.photographersedit.com/wp-content/uploads/2023/07/Emily-Sommer-Photography-web-768x768.jpg",
    title: "School Retouching",
    para1:
      "School photos capture some of the most cherished memories, and at https://captureedits.com/, we’re dedicated to enhancing those moments to make them truly unforgettable. Our School Photography Editing services are designed to bring out the best in your photos, giving them a realistic, polished look that highlights your natural beauty. The final images you receive will be clearer, more vibrant, and full of charm.",
    para2: "Our School Retouching Services include:",

    list1: "Color Correction",
    list2: "Image Straightening",
    list3: "Basic Retouching",
    list4: "Mark Removal",
    list5: "Teeth and Eye Whitening",
    para3:
      "The end result? Perfectly edited photos that capture the essence of your school days with subtle yet impactful enhancements. Let us help you create school photos that you’ll treasure forever!",
  },
];
